import { NgModule } from '@angular/core';
import { AdminConfigPage } from 'pages/admin-config/admin-config';
import { ComponentsModule } from 'components/components.module';
import { PagesModule } from 'pages/pages.module';

@NgModule({
    declarations: [AdminConfigPage],
    imports: [PagesModule, ComponentsModule],
    exports: [AdminConfigPage]
})
export class AdminConfigPageModule {}
